import { Component, Input } from '@angular/core';
import { RSF } from '../../../rsf';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Field } from '../../../rsf.service';

@Component({
  selector: 'rsf-main-s1-functional-tests',
  templateUrl: './rsf-main-s1-functional-tests.component.html',
  styleUrls: ['./rsf-main-s1-functional-tests.component.scss']
})
export class RsfMainS1FunctionalTestsComponent
{
  @Input() rsf?: RSF | null;
  @Input() disabled?: boolean;
  @Input() checkDiff!: (field: Field) => boolean;

  field = Field;

  ctrlFunctionalTest = new FormControl();
  ctrlFunctionalTests = new FormControl();

  onFunctionalTestChanged(e: MatCheckboxChange)
  {
    this.rsf!.functionalTests = e.checked;
  }
}
